<script setup lang="ts">
import type { EquipItemType } from '@/types/equip'
import EquipInfo from './EquipInfo.vue'
import { equipCollection } from '@/core/equip'
import { computed } from 'vue'
import { useUserStore } from '@/stores/modules/user'

const userStore = useUserStore()
const props = defineProps<{ equipInfo: EquipItemType }>()
const emits = defineEmits(['close'])

const equippedInfo = computed<EquipItemType | undefined>(() => {
  const type = props.equipInfo.type
  const id = userStore.equippedList[type]
  if (!id) return undefined
  const itemInfo = userStore.itemList.find((item) => item.id === id)!
  const { name, attrs } = equipCollection[itemInfo.equipId]
  return { ...itemInfo, name, type, attrs }
})
</script>

<template>
  <div class="equip-comparsion">
    <div class="module equipped">
      <h5>已装备</h5>
      <template v-if="equippedInfo">
        <EquipInfo :equip-info="equippedInfo" :showLock="false" :is-in-items="false" :is-in-comparison="true" @close-compare="emits('close')" />
      </template>
      <template v-else>
        <p style="text-align: center">(未装备)</p>
      </template>
    </div>
    <div class="module in-items">
      <h5>物品栏</h5>
      <EquipInfo :equip-info="equipInfo" :showLock="false" :is-in-items="true" :is-in-comparison="true" @close-compare="emits('close')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.equip-comparsion {
  display: flex;
  justify-content: space-between;
  h5 {
    margin: 10px 0;
  }
  .module {
    width: calc(50% - 5px);
    border: 2px var(--fontColor) solid;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-flow: column nowrap;
    min-height: 320px;
  }
}
</style>
